/**
 * Shared responsive patterns (reference: Footer userFooter.js).
 * Breakpoints: mobile <768px, tablet 768–1024px, desktop >1024px
 */

export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

/** Page / section wrapper — prevents horizontal overflow */
export const pageShellSx = {
  width: "100%",
  maxWidth: "100vw",
  overflowX: "hidden",
  boxSizing: "border-box",
};

/** Main content container with responsive horizontal padding */
export const pageContainerSx = {
  ...pageShellSx,
  px: { xs: 2, sm: 3, md: 4, lg: 6 },
  py: { xs: 2, sm: 3 },
};

/** Wrap MUI Table or raw <table> for mobile horizontal scroll */
export const responsiveTableWrapSx = {
  width: "100%",
  maxWidth: "100%",
  overflowX: "auto",
  WebkitOverflowScrolling: "touch",
  "& table": {
    minWidth: { xs: 480, md: 650 },
  },
};

/** Dialog / modal paper sizing */
export const responsiveDialogPaperSx = {
  width: { xs: "calc(100vw - 24px)", sm: "90vw", md: "auto" },
  maxWidth: { xs: "calc(100vw - 24px)", sm: 560, md: 720, lg: 900 },
  maxHeight: { xs: "90vh", md: "85vh" },
  overflowY: "auto",
  m: { xs: 1.5, sm: 2 },
};

/** Full-width media (banners, hero images) */
export const responsiveMediaSx = {
  width: "100%",
  maxWidth: "100%",
  height: "auto",
  objectFit: "cover",
  display: "block",
};

/** Banner / carousel box */
export const responsiveBannerBoxSx = {
  width: "100%",
  maxWidth: { xs: "100%", md: 1280 },
  mx: "auto",
  overflow: "hidden",
  borderRadius: "10px",
  height: { xs: "auto", sm: 200, md: 235 },
  minHeight: { xs: 140, sm: 200 },
  position: "relative",
};

/** MUI useMediaQuery strings aligned with project breakpoints */
export const MQ_MOBILE = "(max-width:767px)";
export const MQ_TABLET_DOWN = "(max-width:1023px)";
export const MQ_DESKTOP = "(min-width:1024px)";

/** Centered MUI Modal <Box> — use in sx alongside position/transform */
export const centeredModalBoxSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "calc(100vw - 24px)", sm: 400, md: 480 },
  maxWidth: "100%",
  maxHeight: { xs: "90vh", md: "85vh" },
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
};
